<template>
  <overview-table
    title="Sócio-Torcedor"
    :headers="headers"
    :items="items"
    :footers="[footer]"
  >
    <template #no-data>
      <h4>Não existem reservas ativas no momento para este evento.</h4>
    </template>
  </overview-table>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import type Overview from '@/types/Overview'
import OverviewTable from './partials/OverviewTable.vue'

const { overview } = defineProps<{ overview: Overview }>()

// --- Items ---
const items = computed(() => overview.signatures)

// --- Header ---
const headers = ref([
  { key: 'name', value: 'name', title: 'Plano', sortable: false },
  { key: 'quantity', value: 'quantity', title: 'Acessos', sortable: true },
])

// --- Footer ---
const footer = computed(
  () => ({
    name: 'Total',
    quantity: overview.signatures.reduce((acc, next) => acc + next.quantity, 0),
  }),
)
</script>
